const TAG_COLORS = {
  trading:      { bg: 'rgba(59,130,246,0.10)',  border: 'rgba(59,130,246,0.25)',  color: '#60a5fa' },
  crypto:       { bg: 'rgba(245,158,11,0.10)',  border: 'rgba(245,158,11,0.25)',  color: '#fbbf24' },
  patterns:     { bg: 'rgba(168,156,247,0.10)', border: 'rgba(168,156,247,0.25)', color: '#a89cf7' },
  backtesting:  { bg: 'rgba(34,197,94,0.10)',   border: 'rgba(34,197,94,0.25)',   color: '#4ade80' },
  ai:           { bg: 'rgba(236,72,153,0.10)',   border: 'rgba(236,72,153,0.25)', color: '#f472b6' },
  data:         { bg: 'rgba(14,165,233,0.10)',   border: 'rgba(14,165,233,0.25)', color: '#38bdf8' },
  nlp:          { bg: 'rgba(192,132,252,0.10)',  border: 'rgba(192,132,252,0.25)',color: '#c084fc' },
  default:      { bg: 'rgba(124,111,239,0.10)',  border: 'rgba(124,111,239,0.20)',color: 'var(--accent2)' },
};

export default function Tag({ label, onClick, active }) {
  const colors = TAG_COLORS[label?.toLowerCase()] || TAG_COLORS.default;
  return (
    <span
      onClick={onClick}
      style={{
        display: 'inline-block',
        padding: '3px 10px',
        borderRadius: 99,
        fontSize: 11,
        fontWeight: 500,
        background: active ? colors.color : colors.bg,
        color: active ? '#0a0a0f' : colors.color,
        border: `1px solid ${active ? colors.color : colors.border}`,
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.15s ease',
        letterSpacing: '0.01em',
      }}
    >
      {label}
    </span>
  );
}
